module.exports = __webpack_public_path__ + "static/img/about4.fdfef73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/about4.jpg
// module id = 70PT
// module chunks = 3